import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d750105"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "alert alert-primary text-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Loading", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Please wait a moment...", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "list-group mt-3"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "d-flex justify-content-end" }
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isLoadingPlaces)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
    : (_ctx.places.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.places, (place) => {
            return (_openBlock(), _createElementBlock("li", {
              key: place.id,
              class: _normalizeClass([{ 'active': place.id === _ctx.activePlace }, "list-group-item list-group-item-action"]),
              onClick: ($event: any) => (_ctx.onPlaceClicked(place))
            }, [
              _createElementVNode("h5", null, _toDisplayString(place.text), 1),
              _createElementVNode("p", null, _toDisplayString(place.place_name), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: _normalizeClass([(place.id === _ctx.activePlace) ? 'btn-outline-light' : 'btn-outline-primary', "btn btn-sm"]),
                  onClick: _withModifiers(($event: any) => (_ctx.getRouteDirections(place)), ["self"])
                }, "Addresses", 10, _hoisted_8)
              ])
            ], 10, _hoisted_6))
          }), 128))
        ]))
      : _createCommentVNode("", true)
}